import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "mt-2 px-3"
};
const _hoisted_2 = {
  class: "text-black"
};
const _hoisted_3 = {
  key: 0,
  class: "text-black"
};
import { computed } from 'vue';
import LlSelect from '@/components/LlSelect.vue';
export default {
  __name: 'QuickbookProductService',
  props: {
    tabValue: {
      type: [Number, String],
      required: true
    },
    services: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: Object,
      default: null
    },
    description: {
      type: String,
      default: ''
    },
    additionalDescription: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'QuickBooks Product/Service'
    },
    customStyle: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const selectedService = computed({
      get: () => props.modelValue,
      set: value => emit('update:modelValue', value)
    });
    const handleServiceChange = value => {
      emit('update:modelValue', value);
    };
    const getSortedArray = items => {
      if (!items || !Array.isArray(items)) {
        return [];
      }
      return items.sort((a, b) => a.name?.localeCompare(b.name));
    };
    return (_ctx, _cache) => {
      const _component_v_label = _resolveComponent("v-label");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_window_item = _resolveComponent("v-window-item");
      return _openBlock(), _createBlock(_component_v_window_item, {
        value: __props.tabValue,
        class: "window-item w-full",
        variant: "tonal",
        style: _normalizeStyle(__props.customStyle)
      }, {
        default: _withCtx(() => [_createVNode(_component_v_row, {
          class: "w-full d-flex flex-wrap ga-4"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_col, null, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString(__props.description || 'Select the QuickBooks Product/Service to which the item should map.'), 1), __props.additionalDescription ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.additionalDescription), 1)) : _createCommentVNode("", true)]), _createVNode(_component_v_label, {
              class: "px-3"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("QuickBooks Product/Service", -1)]))]),
              _: 1
            }), _createVNode(_component_v_col, {
              cols: "12",
              sm: "6",
              md: "10",
              class: "p-0"
            }, {
              default: _withCtx(() => [_createVNode(LlSelect, {
                items: getSortedArray(__props.services),
                modelValue: selectedService.value,
                "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => selectedService.value = $event), handleServiceChange],
                "item-value": "id",
                "item-title": "name",
                density: "compact",
                "return-object": "",
                clearable: "",
                "hide-details": "true",
                labelClass: "text-sm at-choose-client remove-outline",
                isAutocomplete: "",
                placeholder: __props.placeholder || 'QuickBooks Product/Service'
              }, null, 8, ["items", "modelValue", "placeholder"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["value", "style"]);
    };
  }
};